<app-grid [data]="data">     
    <kendo-grid-column field="id" title="" [width]="50">
        <ng-template kendoGridCellTemplate let-row>
            <a class="text-primary link-box" [routerLink]="['/vessel-visit-document/view', row.id]">
                {{row.id}}
            </a>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="documentTypeId" title="{{'Document Type' | translate}}" [width]="200">
        <ng-template kendoGridCellTemplate let-row>
            <span>{{row.documentTypeId | codelist:'DocumentType' | async}} </span>
        </ng-template>
    </kendo-grid-column>   
    <kendo-grid-column field="id" title="{{'Status' | translate}}" [width]="200">
        <ng-template kendoGridCellTemplate let-row>
            <span [pill]="{ status: row.statusId, module: 'VesselVisitDocumentStatus' }">
                {{row.status?.name}}
            </span>
        </ng-template>
    </kendo-grid-column>   
    <kendo-grid-column field="createdDate" title="{{'Created Date' | translate}}" [width]="200">
        <ng-template kendoGridCellTemplate let-row>
            <span>{{ row.createdDate | date:'dd/MM/yyyy HH:mm' }}</span>
        </ng-template>
    </kendo-grid-column>    
    <kendo-grid-column field="createdBy" title="{{'Created By' | translate}}" [width]="200">
        <ng-template kendoGridCellTemplate let-row>
            <span>{{row.createdBy?.fullName}} </span>
        </ng-template>
    </kendo-grid-column>   
    <kendo-grid-column field="lastModifiedDate" title="{{'Last Modified Date' | translate}}" [width]="200">
        <ng-template kendoGridCellTemplate let-row>
            <span>{{ row.lastModifiedDate | date:'dd/MM/yyyy HH:mm' }}</span>
        </ng-template>
    </kendo-grid-column>     
    <kendo-grid-column field="lastModifiedBy" title="{{'Last Modified By' | translate}}" [width]="200">
        <ng-template kendoGridCellTemplate let-row>
            <span>{{row.lastModifiedBy?.fullName}} </span>
        </ng-template>
    </kendo-grid-column> 
</app-grid>